module.exports = __webpack_public_path__ + "static/media/teton_sunset.d11a1a03.jpeg";